var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 52,
    viewBox: "0 0 73 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 2H9.5C5.35786 2 2 4.98477 2 8.66667V43.3333C2 47.0152 5.35786 50 9.5 50H63.5C67.6421 50 71 47.0152 71 43.3333V8.66667C71 4.98477 67.6421 2 63.5 2Z",
    stroke: "#5a9dd9",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.788 11.028L19.46 40.5H24.5L27.524 32.34H38.804L41.828 40.5H46.916L35.588 11.028H30.788ZM33.14 17.124L37.172 28.02H29.108L33.14 17.124Z",
    fill: "#5a9dd9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.788 11.028L27.46 40.5H32.5L35.524 32.34H46.804L49.828 40.5H54.916L43.588 11.028H38.788ZM41.14 17.124L45.172 28.02H37.108L41.14 17.124Z",
    fill: "#5a9dd9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.33d7d83b4db95cfc6e0794efc40b0ec1.svg";
export { ForwardRef as ReactComponent };